import instance from "../store/actions/instance";

// Optional conversion forwarding must never reject a completed cart action.
export const postPixelEvent = (...args) => {
  try {
    return Promise.resolve(instance.post(...args)).catch(() => null);
  } catch (_) { return Promise.resolve(null); }
};
